export enum SourceModuleType {
  Attendant = 'attendant',
  Maintenance = 'maintenance',
  Housekeeping = 'housekeeping',
  AttendantPosting = 'attendant-posting',
  HousekeepingPosting = 'housekeeping-posting',
  TaskManagement = 'task-management',
  Other = 'other'
}



// WEBPACK FOOTER //
// ./src/shared/enum/SourceModuleType.ts